<template>
  <div>
    <header>
      <van-dropdown-menu>
        <van-dropdown-item v-model="value" :options="option" />
      </van-dropdown-menu>
    </header>
    <main>
      <div class="header">
        <b>B区12号桌</b> <span class="label">在店使用</span>
      </div>
      <div class="main">
        <van-sidebar v-model="activeKey" @change="changeKey()">
          <div v-for="(dish, index) in dishes" :key="index">
            <van-sidebar-item
              :class="activeKey == index ? 'active' : ''"
              v-if="dish.status"
              :title="dish.name"
            ></van-sidebar-item>
          </div>
          <div class="myOrder">我的订单</div>
        </van-sidebar>
        <div class="dishContent">
          <span class="actName">{{ actName }}</span>
          <template v-if="actMenus.length > 0">
            <div
              class="dishItem"
              v-for="(menu, index) in actMenus"
              :key="menu.id"
            >
              <div class="dishImage">
                <img class="image" :src="menu.image.path" alt="" />
              </div>
              <div class="menu_main">
                <p class="title">{{ menu.name }}</p>
                <p class="introduction">{{ menu.introduction }}</p>
                <p class="price">
                  ￥<span>{{ menu.original_price }}</span>
                </p>
                <p class="dishContent_footer">
                  <span class="specs">详情</span>
                  <van-stepper
                    default-value="0"
                    min="0"
                    integer
                    :long-press="false"
                    :show-minus="menu.count == 0 ? false : true"
                    :show-input="menu.count == 0 ? false : true"
                    v-model="menu.count"
                    @plus="Dish(menu.id, index, 1, 'add')"
                    @minus="Dish(menu.id, index, 1, 'sub')"
                  />
                  <!-- <van-badge :content="5">
                    <span class="specs">选规模</span>
                  </van-badge> -->
                </p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </main>
    <footer>
      <div>
        <van-icon
          name="shopping-cart-o"
          :badge="totalNumber"
          size="35px"
          color="red"
        />
        <div class="footer_right">
          <span class="total_price"
            >￥ <span>{{ shopCart.total }}</span></span
          >
          <span class="checkout">去结算</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dishes: [], //所有产品
      actMenus: [], //当前产品列表
      shopCart: [], //购物车
      actName: "",
      activeKey: 0,
      value: 0,
      totalNumber: 0,
      option: [
        { text: "简体中文", value: 0 },
        { text: "繁体中文", value: 1 },
        { text: "English", value: 2 }
      ]
    };
  },
  mounted() {
    // 保存上次选择的tab栏选项
    if (sessionStorage.getItem("activeKey")) {
      this.activeKey = Number(sessionStorage.getItem("activeKey"));
    } else {
      this.activeKey = 0;
    }
    this.getDishes();
    this.getShopCart();
  },
  methods: {
    // 获取产品列表
    getDishes() {
      this.$toast({
        duration: 0,
        type: "loading",
        message: "加载中...",
        forbidClick: true
      });
      // 获取 菜品列表——全部 —— 计算数量
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build +
          "/api/store/" +
          sessionStorage.storeId +
          "/customerMenus/in/" +
          sessionStorage.placeId
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            let dishes = [];
            res.data.data.forEach(item => {
              if (item.status == 1) {
                dishes.push(item);
              }
            });
            this.dishes = dishes;
            this.$toast.clear();
            // this.dishes = res.data.data;
            // this.dishes.forEach(item => {
            //   if (item.status == 1) {
            //     item.status = true;
            //   } else {
            //     item.status = false;
            //   }
            // });
            // this.getPackages();
            this.actMenus = this.dishes[this.activeKey].menus;
            this.actName = this.dishes[this.activeKey].name;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast.clear();
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 获取套餐列表
    getPackages() {
      // 获取 菜品列表——套餐
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build +
          "/api/store/" +
          sessionStorage.storeId +
          "/customerPackages/in"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.packages = res.data.data;
            var packages = {};
            packages.name = this.$t("Dishes.package");
            packages.menus = res.data.data;
            this.dishes = this.prepend(this.dishes, packages);
            this.actMenus = this.dishes[this.activeKey].menus;
            this.isAll = true;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 获取购物车
    getShopCart() {
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build +
          "/api/place/" +
          sessionStorage.placeId +
          "/customerShopcart"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.shopCart = res.data;
            this.totalNumber = 0;
            this.shopCart.data.forEach(item => {
              let arr = [];
              this.totalNumber = this.totalNumber + item.number;
              if (item.menus_name.length != 0 && item.tags_name) {
                // 套餐偏好重新排版
                item.tags_name.forEach((i, num) => {
                  i.forEach((j, index) => {
                    let list = []; //临时存储
                    if (i.length > 1) {
                      list.push(`(${item.menus_name[num][index]})：`);
                    }
                    if (typeof j == "object") {
                      j.forEach(tag => {
                        list.push(tag);
                      });
                    } else {
                      list.push(j);
                    }
                    i.splice(index, 1, list);
                  });
                });
              } else if (item.menus_name.length == 0 && item.tags_name) {
                // 单品偏好重新排版
                if (item.tags_name[0] != "") {
                  item.tags_name.forEach(i => {
                    i.forEach(j => {
                      if (typeof j == "object") {
                        j.forEach(tag => {
                          arr.push(tag);
                        });
                      } else {
                        arr.push(j);
                      }
                    });
                  });
                }
                item.tags_name = arr;
              }
            });
          } else {
            // for (var item in res.data.error) {
            //     this.$toast({
            //         duration:2000,
            //         type:'fail',
            //         message:res.data.error[item],
            //     });
            // }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 加减产品
    Dish(id, index, number, type) {
      let url = "";
      if (type == "add") {
        url = "/api/shopcart/customerCreated";
      } else {
        url = "/api/shopcart/customerReduced";
      }
      this.$axios({
        method: "POST",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url: this.$build + url,
        data: {
          place_id: sessionStorage.placeId,
          menu_id: id,
          number
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.actMenus[index].count = this.actMenus[index].count;
            this.$toast({
              type: "success",
              message: res.data.message.replace(" ", "  \n"),
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 切换分类
    changeKey() {
      sessionStorage.setItem("activeKey", this.activeKey);
      this.actMenus = this.dishes[this.activeKey].menus;
      this.actName = this.dishes[this.activeKey].name;
    }
  }
};
</script>

<style scoped>
header {
  height: 3.125rem;
  background-color: #e63837;
}
/deep/ .van-dropdown-menu__bar {
  width: 25%;
  margin: 0 auto;
  background-color: #e63837;
  box-shadow: none;
}
/deep/ .van-dropdown-menu__title {
  color: #fff;
  font-size: 1rem;
}
/deep/ .van-sidebar {
  width: 90px;
  position: relative;
}
/deep/ .van-stepper__plus {
  background-color: #e63837;
  color: #fff;
  border-radius: 10px;
}
/deep/ .van-stepper__plus::after {
  width: 2px;
}
/deep/ .van-stepper__plus::before {
  height: 2px;
}
/deep/ .van-stepper__minus {
  border: 1px solid #f19595;
  background-color: #fff;
  color: #000;
  border-radius: 10px;
}
/deep/ .van-stepper__input {
  background: none;
}
.header {
  padding: 0.625rem;
  background-color: #fff;
}
.header b {
  display: inline-block;
  padding: 0.3125rem 0.625rem;
}
.header .label {
  font-size: 1rem;
  padding: 0.3125rem 0.625rem;
  border-radius: 0.9375rem;
  float: right;
  color: #fff;
  background-color: #e63837;
}
.main {
  display: flex;
  justify-content: space-between;
  height: 81vh;
}
.van-sidebar-item {
  background-color: #fff;
  margin: 1.25rem 0rem;
  padding: 0.625rem 0.75rem;
  text-align: center;
  border-radius: 0px 28px 30px 0px;
  font-size: 1rem;
}
.van-sidebar {
  display: inline-block;
}
.active {
  color: #fff;
  background-color: #e63837;
}
.dishImage {
  width: 6.875rem;
  height: 4.6875rem;
}
.image {
  width: 100%;
  height: 100%;
}
.actName {
  margin: 0.625rem 1.25rem 0.625rem;
  display: inline-block;
  color: #878787;
  font-weight: bold;
}
.dishContent {
  width: 75%;
  height: 100%;
  background: #fff;
}
.dishItem {
  padding: 10px 0px;
  display: flex;
  width: 90%;
  margin: 0rem 0rem 0.625rem 1.25rem;
}
.dishItem .menu_main {
  margin-left: 10px;
  width: 100%;
}
.dishItem p {
  margin: 0;
  padding: 0;
}
.dishItem .title {
  color: #000;
  font-size: 20px;
}
.dishItem .introduction {
  color: #a9a9a9;
  font-size: 14px;
}
.dishContent_footer {
  display: flex;
  justify-content: space-between;
}
.dishContent_footer span {
  display: inline-block;
}
.dishItem .price {
  color: #fd0504;
  font-weight: bolder;
  font-size: 16px;
}
.dishItem .price span {
  font-size: 24px;
}
.dishItem p:last-child {
  margin-top: 10px;
}
.dishItem .specs {
  color: #fff;
  padding: 4px 10px;
  background: #e63837;
  cursor: pointer;
  border-radius: 10px;
  font-size: 14px;
}
.dishItem .van-badge__wrapper {
  float: right;
  margin-right: 10px;
}
footer {
  display: block;
  width: 100%;
  height: 3.4375rem;
  /* border: 1px solid #fd0504; */
  position: fixed;
  bottom: 0;
  background-color: #fff;
  max-width: 500px !important;
}
footer > div {
  display: flex;
  justify-content: space-between;
  height: 55px;
  position: relative;
}
.myOrder {
  position: absolute;
  bottom: 10px;
  background: repeating-linear-gradient(to bottom, #ff7805, #ff4730);

  padding: 10px 10px;
  color: #fff;
  border-radius: 0px 30px 30px 0px;
}
footer .van-icon {
  position: relative;
  left: 15px;
  top: 10px;
}
.footer_right {
  line-height: 50px;
}
.total_price {
  color: #fd0504;
  font-size: 20px;
  font-weight: bolder;
  position: relative;
  top: 5px;
  right: 10px;
}
.total_price span {
  font-size: 30px;
}
.checkout {
  color: #fff;
  font-size: 18px;
  background-color: #e63837;
  padding: 12px 25px;
  margin-right: 15px;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/newDishes.vue